/* eslint-disable @typescript-eslint/camelcase */
import { Plugin } from '../../types';

function guidGenerator() {
  const S4 = function() {
    return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
  };
  return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}
export const mocker: Plugin = {
  name: 'coverage',
  test:{
    collector: true,
    hook: {
      async afterAll(page): Promise<void>{
        const NYC_DIR = '.nyc_output'
        const path = require('path')
        const COV_MERGE_DIR = path.join(NYC_DIR, 'merge')

        const coverage = await page.evaluate(`window.__coverage__`)
        require('fs').writeFileSync(path.join(COV_MERGE_DIR, `${guidGenerator()}.json`), JSON.stringify(coverage))
      }
    }
  },
}
export default mocker

